<mat-icon style="width: 80px; height: 80px;" svgIcon="twe:empty"></mat-icon>
<p class="mt-2 mb-4 fs-6 text-secondary" [ngSwitch]="hasFilters">
  <ng-container *ngSwitchCase="true">
    <ng-content select=".no-results"></ng-content>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-content select=".no-data"></ng-content>
  </ng-container>
</p>